import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch } from 'react-redux';
import { achievementTokensApiSlice } from '@/api/achievementTokensApiSlice';
import { skillTagsSlice } from '@/pages/AwardTokensPage/skillTagsSlice';
import lessonCompletionApiSlice from '@/api/lessonCompletionApiSlice';
export const store = configureStore({
    reducer: {
        skillTags: skillTagsSlice.reducer,
        [achievementTokensApiSlice.reducerPath]: achievementTokensApiSlice.reducer,
        [lessonCompletionApiSlice.reducerPath]: lessonCompletionApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(achievementTokensApiSlice.middleware)
        .concat(lessonCompletionApiSlice.middleware),
});
setupListeners(store.dispatch);
export const useAppDispatch = () => useDispatch();
